import Chip, { ChipProps } from "@mui/material/Chip";

/** Renders the Pillbox(Chips) */
const PillBox = (props: ChipProps) => {
  return <Chip {...props} />;
};

export default PillBox;
